"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _warning = _interopRequireDefault(require("warning"));

var _nativeSelect = _interopRequireDefault(require("../native-select"));

var _inputLabel = _interopRequireDefault(require("../input-label"));

var _inputHelperText = _interopRequireDefault(require("../input-helper-text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      dropdownClassName = _ref.dropdownClassName,
      errorState = _ref.error,
      id = _ref.id,
      InputHelperTextProps = _ref.InputHelperTextProps,
      InputLabelProps = _ref.InputLabelProps,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      required = _ref.required,
      SelectProps = _ref.SelectProps,
      warning = _ref.warning,
      restOfSelectProps = _objectWithoutProperties(_ref, ["children", "disabled", "dropdownClassName", "error", "id", "InputHelperTextProps", "InputLabelProps", "onBlur", "onFocus", "required", "SelectProps", "warning"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      toggleFocus = _useState2[1];

  var setFocus = function setFocus(e) {
    if (typeof onFocus === 'function') {
      onFocus(e);
    }

    toggleFocus(true);
  };

  var unsetFocus = function unsetFocus(e) {
    if (typeof onBlur === 'function') {
      onBlur(e);
    }

    toggleFocus(false);
  };

  var warningState = warning;
  /**
   * We cannot have both warning and error state be true for the input field
   * Default to using the error state instead
   */

  if (warningState && errorState) {
    (0, _warning.default)(!warningState && errorState, 'PDS::DROPDOWN: warning and error cannot both be set to true; using error instead.');
    warningState = false;
  }
  /**
   * Once custom dropdowns are built, add the logic here to render based on a `native` prop
   */


  var SelectComponent = _nativeSelect.default;
  /**
   * If a "helperText" is used, a "helperTextId" should also be provided to link
   * "aria-describedby" on the input with the helper text id for accessibility
   */

  var HelperTextProps = InputHelperTextProps ? _objectSpread({}, InputHelperTextProps) : {};
  /**
   * Provide an id for the helperText only if it is not explicitly defined by users
   */

  if (!HelperTextProps.id) {
    HelperTextProps.id = "".concat(id, "-helper-text");
  }

  var dropdownClasses = (0, _classnames.default)(dropdownClassName, {
    'pds-dropdown': true
  });
  return _react.default.createElement("div", {
    className: dropdownClasses
  }, _react.default.createElement(_inputLabel.default, _extends({}, InputLabelProps, {
    disabled: disabled,
    error: errorState,
    htmlFor: id
  })), _react.default.createElement(SelectComponent, _extends({}, restOfSelectProps, SelectProps, {
    disabled: disabled,
    error: errorState
    /* The focused prop will be used in the future for custom select components */
    ,
    focused: focused,
    id: id,
    onFocus: setFocus,
    onBlur: unsetFocus,
    required: required,
    warning: warningState
  }), children), HelperTextProps.text && _react.default.createElement(_inputHelperText.default, {
    className: HelperTextProps.className,
    id: HelperTextProps.id,
    disabled: disabled,
    text: HelperTextProps.text
    /* The helper text is visible even if the Dropdown is not focused */
    ,
    active: !errorState && !warningState
  }), HelperTextProps.warningText && _react.default.createElement(_inputHelperText.default, {
    text: HelperTextProps.warningText,
    className: HelperTextProps.warningTextClassName,
    active: !errorState && warningState
  }), _react.default.createElement(_inputHelperText.default, {
    className: HelperTextProps.errorTextClassName,
    text: HelperTextProps.errorText,
    active: errorState,
    error: errorState
  }));
};

Dropdown.propTypes = {
  /**
   * Native HTML option elements to be used inside the Dropdown. This should
   * come as a flat list of nodes (no parent wrapper).
   */
  children: _propTypes.node.isRequired,

  /**
   * Whether or not the select element can be selected. This is used by
   * the `InputLabel` as well.
   */
  disabled: _propTypes.bool,

  /**
   * Applies additional CSS classes to the Dropdown wrapper element.
   */
  dropdownClassName: _propTypes.string,

  /**
   * Applies error state styling to the `SelectComponent`, `InputLabel`,
   * and `InputHelperText` components. Only one of `error` or `warning`
   * props can be set to true at any given time; error will take
   * precedence over warning.
   */
  error: _propTypes.bool,

  /**
   * HTML attribute used by SelectComponent. It is also used as a fallback
   * to generate an accessibility label that links the `InputHelperText`
   * component with the `SelectComponent` (if HelperTextProps.id does
   * not exist).
   */
  id: _propTypes.string.isRequired,

  /**
   * Props used by the `InputHelperText` component. See `InputHelperText`
   * for all available options.
   */
  InputHelperTextProps: (0, _propTypes.shape)({
    className: _propTypes.string,
    errorText: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)(_propTypes.string)]),
    errorTextClassName: _propTypes.string,
    id: _propTypes.string,
    text: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)(_propTypes.string)]),
    warningText: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)(_propTypes.string)]),
    warningTextClassName: _propTypes.string
  }),

  /**
   * Props used by the `InputLabel` component, where the `text` prop is
   * required. See `InputLabel` for all available options.
   */
  InputLabelProps: (0, _propTypes.shape)({
    text: _propTypes.string.isRequired
  }).isRequired,

  /**
   * Event handler passed down to the native HTML select element that is
   * invoked when focus is removed.
   */
  onBlur: _propTypes.func,

  /**
   * Event handler passed down to the native HTML select element that is
   * invoked when focus is set.
   */
  onFocus: _propTypes.func,

  /**
   * Whether or not the HTML select option is required before a form
   * submission can occur.
   */
  required: _propTypes.bool,

  /**
   * Props used by the `SelectComponent`. See `NativeSelect` for all available
   * options.
   */
  SelectProps: (0, _propTypes.shape)({}),

  /**
   * Applies warning state styling to the select element. Only one of `error`
   * or `warning` props can be set to true at any given time; error will
   * take precedence over warning.
   */
  warning: _propTypes.bool
};
Dropdown.defaultProps = {
  disabled: false,
  dropdownClassName: null,
  error: false,
  InputHelperTextProps: null,
  onBlur: null,
  onFocus: null,
  required: false,
  SelectProps: null,
  warning: false
};
var _default = Dropdown;
exports.default = _default;
